import type { ComponentProps } from "react";
import { Link } from "react-router";
import { cn } from "./cn";
import { Icon } from "./icon";

/**
 * The "back to the list" link above the title of a detail page: the one back link of the staff console. The words are the children and the
 * arrow is a decorative icon, so the accessible name is the words alone. Pass it as `breadcrumbs` of `PageHeader` (or put it first on a page).
 */
export function BackLink({ className, children, ...props }: ComponentProps<typeof Link>) {
  return (
    <Link
      className={cn(
        "inline-flex min-h-11 w-fit items-center gap-2 justify-self-start text-sm font-medium text-link hover:underline compact:min-h-8",
        className,
      )}
      {...props}
    >
      <Icon name="arrow-left-02-round" className="size-4 shrink-0" />
      {children}
    </Link>
  );
}

/**
 * A link inside a `DataTable` cell. The target is 44 px high in the comfortable density and 32 px in the compact one (ADR 0016), and the
 * negative margin takes back the cell padding, so the row keeps its 48 px or 36 px.
 */
export function TableLink({ className, ...props }: ComponentProps<typeof Link>) {
  return (
    <Link
      className={cn(
        "-my-2 inline-flex min-h-11 items-center font-medium text-link underline-offset-4 hover:underline compact:-my-1 compact:min-h-8",
        className,
      )}
      {...props}
    />
  );
}
